export default {
      id: "dropdown-arrow-usage",
      viewBox: "0 0 10 7",
      url: __webpack_public_path__ + "sprite-46b249.svg#dropdown-arrow-usage",
      toString: function () {
        return this.url;
      }
    }